import(/* webpackMode: "eager", webpackExports: ["Hide"] */ "/vercel/path0/components/markdown/Hide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HideResetButton"] */ "/vercel/path0/components/markdown/HideResetButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HideUsageGuide"] */ "/vercel/path0/components/markdown/HideUsageGuide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/navigation/LoginDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/resources/KenchikuCodeSearchClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/resources/KenchikuCodeViewerClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/resources/SafetyCertificateForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/resources/ZumenDownload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BuildingLoadTable"] */ "/vercel/path0/data/resources/database/building-load/components/building-load-table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SteelSectionTable"] */ "/vercel/path0/data/resources/database/h-steel-section-data/components/SteelSectionTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WoodConnectionTable"] */ "/vercel/path0/data/resources/database/wood-connection/components/WoodConnectionTable.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
